export default __webpack_public_path__ + "static/media/no-data-icon.26e062ee.svg";